import { Country, AoMember, MasterData } from '@model/master-data.model';

import { PackageTypeCatagory } from '@enum/quotation.enum';

export const TYPE_LIST: MasterData[] = [
  { code: PackageTypeCatagory.INDIVIDUAL, descEn: 'Individual', descTh: 'รายบุคคล' },
  { code: PackageTypeCatagory.GROUP, descEn: 'Group', descTh: 'กลุ่ม' },
  { code: PackageTypeCatagory.FAMILY, descEn: 'Family', descTh: 'ครอบครัว' }
];

export const THAILAND_CODE: string = 'AS041';

export const DEFAULT_COUNTRY_LIST: Country[] = [
  { code: THAILAND_CODE, descEn: 'Thailand', descTh: 'ไทย' },
  { code: 'APAC', descEn: 'Asia', descTh: 'Asia' },
  { code: 'WW001', descEn: 'World Wide', descTh: 'ทั่วโลก' }
];

export const NON_AO_MEMBER: AoMember = {
  intermediaryId: null,
  aoMemberCode: null,
  memberName: '---'
};

export const DEFAULT_MAX_TO_DATE: number = 179;

export const GET_PRICE_DATE_FORMAT: string = 'DD-MM-YYYY HH:mm:ss';

export const STUDENT_OVERSEA_TOP_LEVEL_ID: string = '129';

export const ANNUAL_TRIP_PERIOD_LIST: MasterData[] = [
  { code: '31', descEn: '31', descTh: '31' },
  { code: '90', descEn: '90', descTh: '90' },
  { code: '120', descEn: '120', descTh: '120' },
  { code: '180', descEn: '180', descTh: '180' },
  { code: '365', descEn: '365', descTh: '365' }
];
